<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="32" height="32" rx="8" fill={primary600} />
  <path
    d="M22.075 11.75L25.875 15.55M25.875 15.55L22.075 19.35M25.875 15.55H13.525M19.225 8.14384C18.014 7.41636 16.608 7 15.1083 7C10.5612 7 6.875 10.828 6.875 15.55C6.875 20.272 10.5612 24.1 15.1083 24.1C16.608 24.1 18.014 23.6836 19.225 22.9562"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
